import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import AnnoncesCard from "../AnnoncesCard";
import style from "./style.module.css";

import PROXY_CONFIG from "Config/ProxyConfig";
import formatUrl from "utils/FormatUrl";
import useTranslation from "next-translate/useTranslation";
import api_call_v2 from "utils/API_CALL/api_call_v2";

// const listings = [
//   {
//     prix: 8000,
//     city: "Casablanca",
//     quartier: "sidi maarouf",
//     sdb: 2,
//     surface: 98,
//     transaction_type: "Location",
//     type: "Appartement",
//     typologie: 3,
//     imageUrl:
//       "https://media.lesechos.com/api/v1/images/view/634e80729fd8896ffe1153cd/par_defaut/image.jpg",
//   },
//   {
//     prix: 3000,
//     city: "Oujda",
//     quartier: "EL Qods",
//     sdb: 2,
//     surface: 115,
//     transaction_type: "Vente",
//     type: "Appartement",
//     typologie: 4,
//     imageUrl:
//       "https://www.shbarcelona.fr/blog/fr/wp-content/uploads/2016/03/appartement-photo.jpg",
//   },
//   {
//     prix: 5000,
//     city: "Rabat",
//     quartier: "Hay El Riad",
//     sdb: 2,
//     surface: 100,
//     transaction_type: "Vente",
//     type: "Appartement",
//     typologie: 3,
//     imageUrl:
//       "https://www.shbarcelona.fr/blog/fr/wp-content/uploads/2016/03/Photo-appartement-3.jpg",
//   },
//   {
//     prix: 2000,
//     city: "Berkane",
//     quartier: "Sidi slimane",
//     sdb: 2,
//     surface: 110,
//     transaction_type: "Vente",
//     type: "Appartement",
//     typologie: 4,
//     imageUrl:
//       "https://www.challenges.fr/assets/img/2022/10/26/cover-r4x3w1200-63595fc246f00-20220404-02.jpg",
//   },
// ];

function index({
  title,
  listings,
  btnText,
  btnLink,
  transaction_type,
}: {
  title: string;
  listings: any;
  btnText: any;
  btnLink: any;
  transaction_type?: string;
}) {
  const { lang } = useTranslation("annonces");
  const refCarousel = useRef(null);
  const [dotIndex, setDotIndex] = useState(0);
  const [dots, setDots] = useState([...Array(4).fill(1)]);

  const handleScroll = () => {
    const scrollLeft = refCarousel.current.scrollLeft;
    const cardWidth = refCarousel.current.offsetWidth;
    const activeCardIndex = Math.round(scrollLeft / cardWidth);
    setDotIndex(activeCardIndex);
  };

  useEffect(() => {
    const scrollable = refCarousel.current;
    scrollable?.addEventListener("scroll", handleScroll);

    return () => {
      scrollable.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [similarListings, setSimilarListings] = useState([]);

  useEffect(() => {
    // if (!similarListings) {
    //     api_call_v2(
    //       undefined,
    //       "post",
    //       "annonces/similaires",
    //       {
    //         lat: 33.589886,
    //         lng: -7.603869,
    //         rooms: 3,
    //         transaction_type: "Location",
    //         type: "Villa",
    //         price: "400000",
    //         vendu: false,
    //       }
    //     )
    //     .then((res) => {
    //       setSimilarListings(res.data.result);
    //     })
    //     .catch((err) => {});
    // }
  }, []);
  return (
    <div className={style.annoncesLpCon}>
      <div className={style.annoncesContainer}>
        <div className={style.cardsTitle}>
          <h2>{title}</h2>
        </div>
        <div>
          <div className={style.cardsContainer} ref={refCarousel}>
            {listings
              ? listings.map((listing, key) => {
                  return (
                    <AnnoncesCard key={key} listing={listing} fromLp={true} />
                  );
                })
              : null}
          </div>
          <div className={style.dotContainer}>
            {dots.map((item, key) => {
              return (
                <div
                  className={`${
                    key === dotIndex ? style.dotActive : style.dot
                  }`}
                ></div>
              );
            })}
          </div>
        </div>
        <div className={style.btnGlobalCon}>
          <div
            className={style.btnContainer}
            data-tracking="click"
            data-value=""
          >
            <a
              href={formatUrl(btnLink, lang)}
              rel={
                btnLink?.includes("list") ||
                btnLink?.includes("map") ||
                btnLink?.includes("?") ||
                btnLink?.includes("conditions") ||
                btnLink?.includes("contact")
                  ? "noindex, nofollow, noreferrer"
                  : "dofollow"
              }
            >
              {btnText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
